<template>
  <span class="text-primary">
    <i class="fa fa-download fa-lg icon-button" title="Download" @click.stop="downloadAnexo()"></i>
  </span>
</template>

<script>
export default {

  props: {

    entregaAnexo: {
      type: Object,
      default: () => ({})
    },

    entregasServicos: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },

  methods: {

    downloadAnexo () {
      this.$store.dispatch('addRequest')
      this.entregasServicos.obterEntregaAnexo(this.entregaAnexo.entregaAnexoId)
        .then((response) => {
          if (response) {
            if (response.type === 'application/json') {
              this.$toast.error('Erro ao realizar download do anexo!!!', 'ERROR', this.$toastConfig.error)
            } else {
              this.$download(response, this.entregaAnexo.nomeArquivoOriginal)
            }
          }
          this.$store.dispatch('removeRequest')
        })
    }
  }
}
</script>